<template>
    <v-text-field
        v-bind='$attrs'
        :value='value'
        :step='$attrs.step ||100000'
        :hint='balanceHint'
        v-on="$listeners"
        @input="v => $emit('input', v)"
    >
        <template #label>
            <slot name='label' />
        </template>
    </v-text-field>
</template>

<script>
    import balanceHint from '../plugins/wordifyfa';

    export default {
        name: 'CustomCurrencyInput',
        inheritAttrs: false,
        props: ['value', 'agreement'],
        computed:{
            balanceHint() {
                if (!this.value) return null;
                return balanceHint(this.value) + ' تومان';
            }
        }
    };

</script>

<style scoped>

</style>